import { useContent } from '../../../hooks/use-server-content';
import { AemVideoQuietCardDetails } from '../../../models/experiencefragments/category-view';

export const useCxVideoquietcardOneContent = (): AemVideoQuietCardDetails | null => {
    let contentFragment: any = {};
    const [content, getValueByName] = useContent(
        'learning-hub/landing-page',
        'video-quiet-card-one'
    );
    content?.elements.forEach(element => {
        contentFragment[`${element.name}`] = getValueByName(`${element.name}`);
    });
    if (Object.entries(contentFragment).length === 0 || contentFragment.hide) {
        contentFragment = null;
    }
    return contentFragment as AemVideoQuietCardDetails;
};
